// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"987b9936","95":"b9354a7a","130":"4e86e25f","167":"c4a2488c","245":"44006e31","484":"2427c74c","548":"7a316173","589":"3f612c51","613":"afb5c455","646":"b02d0aaa","697":"07e2cce3","699":"7e77dd72","854":"10eb6e4f","950":"8a6521cc"}[chunkId] + ".chunk.js";
};